module.exports = __webpack_public_path__ + "02_short_brown.dd8e25fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/02_short_brown.png
// module id = y4dq
// module chunks = 0